
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Applications/collecting-data.html",
      function () {
        return require("private-next-pages/Applications/collecting-data.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Applications/collecting-data.html"])
      });
    }
  